import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem("ss_theme") || "light");

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        localStorage.setItem("ss_theme", theme);
    }, [theme]);

    const toggle = useCallback(() => setTheme(t => t === "dark" ? "light" : "dark"), []);

    const value = useMemo(() => ({ theme, setTheme, toggle }), [theme, toggle]);

    return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}
export const useTheme = () => useContext(ThemeCtx);
